import { gql } from '@apollo/client';
import type { GroupPath_GroupFragment } from '../../graphql/generated/graphqlTypes';
import entityPath from './entityPath';

const GROUP_PATH_GROUP_FRAGMENT = gql`
  fragment groupPath_group on PublicGroupFields {
    id
    name
  }
`;

function groupPath({ id, name }: GroupPath_GroupFragment) {
  return `/groups/${entityPath(name, id)}`;
}

groupPath.fragments = {
  group: GROUP_PATH_GROUP_FRAGMENT,
};

export default groupPath;
